import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { IdName } from 'src/app/shared/models/id-name';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class WeatherInformationApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/WeatherInformations`;
  }

  constructor(private http: HttpClient) {}

  loadWeatherInformation(currentFilter?: MainTableFilterModel): Observable<ApiResponse<IdName[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IdName[]>>(this.url, { params });
  }

  loadAllWeatherInformation(): Observable<IdName[]> {
    const url = `${this.url}/All`;
    return this.http.get<IdName[]>(url);
  }

  loadWeatherInformationById(id: string): Observable<IdName> {
    const url = `${this.url}/${id}`;
    return this.http.get<IdName>(url);
  }

  createWeatherInformation(weatherInformation: IdName): Observable<IdName> {
    return this.http.post<IdName>(this.url, weatherInformation, { headers });
  }

  updateWeatherInformation(weatherInformation: IdName): Observable<IdName> {
    const url = `${this.url}/${weatherInformation.id}`;
    return this.http.put<IdName>(url, weatherInformation, { headers });
  }

  deleteWeatherInformation(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }
}
